import React from "react";
import "./loader.scss";

const Loader = ({ fullscreen, children }) => (
  <div className={`dcrform-loader ${fullscreen ? "dcrform-loader__fullscreen" : ""}`}>
    <div className="dcrform-loader__dount">{children}</div>
  </div>
);

export default Loader;
